module.exports = __webpack_public_path__ + "static/media/p75p.70153fca.jpg";